import React from 'react'

export const AcceptedValue = ({ accepted }: { accepted: boolean }) => {
  return <div>{accepted ? 'Accepted' : 'Rejected'}</div>
}

export const InAssortmentValue = ({ inAssortment }: { inAssortment: boolean }) => {
  return <div>{inAssortment ? 'In assortment' : 'Not in assortment'}</div>
}

export const RefundGroupValue = ({ refund }: { refund: boolean }) => {
  return <div>{refund ? 'Refund group' : ''}</div>
}

export const MinimumCrateItemsValue = ({ minimumCrateItems }: { minimumCrateItems: boolean }) => {
  return <div>{minimumCrateItems ? 'Minimum crate items' : ''}</div>
}

export const SuperGroupValue = ({ superGroup }: { superGroup: boolean }) => {
  return <div>{superGroup ? 'Super group' : ''}</div>
}
